import "babel-polyfill";
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'

import axios from 'axios'
// Vue.prototype.$ajax = axios

Vue.use(Vuex)
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

Vue.config.productionTip = false;

import publicJS from "./assets/publicJS/public.js";
Vue.prototype.publicJS = publicJS;

import ElementUI from 'element-ui';
import '@/assets/theme-green/index.css';
Vue.use(ElementUI);

// 引入muse-ui
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
MuseUI.theme.add('my-theme', {
    primary: '#57BC4C',
    // 　　secondary: '#ff4900',
    // 　　success: '#70af40',
    // 　　warning: '#ff9300'
}, 'light').use('my-theme')
Vue.use(MuseUI);

// import 'muse-ui-message/dist/muse-ui-message.css';
// import Message from 'muse-ui-message';
// Vue.use(Message);

//百度统计
import ba from 'vue-ba'
Vue.use(ba, "43d7e89f2df365f76b28db5d9f5f2afe");
Vue.use(ba, { siteId: "43d7e89f2df365f76b28db5d9f5f2afe" });


import store from './store'


router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    const type = to.meta.type
        // 判断该路由是否需要登录权限
    if (type === 'login') {
        if (window.localStorage.getItem('user')) {
            next()
        } else {
            next('/login')
        }
    } else {
        next() // 确保一定要有next()被调用
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js